import React, { useState } from "react";
import { Button, Divider, Empty, Table } from "antd";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import AccountTableRow from "./account-table-row";
import { useNavigate } from "react-router";
import { amountFormat } from "../services/common.service";
import unCheckedIcon from "../assests/icons/uncheck.png";
import { ReactComponent as CheckedIcon } from "../assests/images/checked.svg";
import { MdOutlineEdit } from "react-icons/md";

export default function AccountGridItem({
  dataSource,
  handleChange,
  setVisible,
  setSelectedDetails,
}) {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useState(true);
  const navigate = useNavigate();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const toggleVisibility = () => {
    setIsHidden(!isHidden);
  };

  return (
    <Table
      dataSource={dataSource}
      rowClassName={(record, index) =>
        index % 2 === 0 ? "table-row-light" : "table-row-dark"
      }
      style={{ cursor: "pointer" }}
      tableLayout="fixed"
      rowKey={"accountNo"}
      pagination={false}
      bordered
      expandable={{
        defaultExpandAllRows: false,
        expandRowByClick: true,
        expandedRowKeys: expandedRowKeys,

        expandIcon: ({ expanded, onExpand, record }) =>
          expanded ? (
            <CheckedIcon
              onClick={(e) => onExpand(record, e)}
              height={18}
              className="checked"
            />
          ) : (
            <img
              src={unCheckedIcon}
              onClick={(e) => onExpand(record, e)}
              height={18}
              className="unchecked"
            />
          ),
        onExpand: (expanded, record) => {
          if (expanded) {
            setExpandedRowKeys([record.accountNo]);
          } else {
            setExpandedRowKeys([]);
          }
        },
        expandedRowRender: (account) => (
          <div className="d-flex align-items-center">
            <Button
              type="default"
              className="secondary-btn"
              onClick={() =>
                navigate("/accounts/summary", {
                  state: { ...account, key: "ACCOUNT_DETAILS" },
                })
              }
            >
              {t("pages.my_accounts.common_my_accounts.ac_details", {
                defaultValue: "A/c Details",
              })}
            </Button>
            <Divider type="vertical" />
            <Button
              type="default"
              className="secondary-btn"
              onClick={() =>
                navigate("/accounts/summary", {
                  state: { ...account, key: "MINI_STATEMENT" },
                })
              }
            >
              {t("navigation.statement", {
                defaultValue: "Statement",
              })}
            </Button>
          </div>
        ),
      }}
      sticky={true}
      columns={[
        {
          title: "Account Number",
          key: "accountNo",
          dataIndex: "accountNo",
          width: 155,
        },
        {
          title: "Account Type",
          key: "accountType",
          width: 135,
          render: (account) => (
            <>
              {account.accountType === "SA" &&
                t("pages.my_accounts.casa.saving", {
                  defaultValue: "Saving",
                })}
              {account.accountType === "CA" &&
                t("pages.my_accounts.casa.current", {
                  defaultValue: "Current",
                })}
              {account.accountType === "ODA" &&
                t("pages.my_accounts.casa.over_draft", {
                  defaultValue: "Over Draft",
                })}
              {account.accountType === "FD" &&
                t("pages.my_accounts.casa.term_depost", {
                  defaultValue: "Term Deposit",
                })}
              {account.accountType === "LA" &&
                t("pages.my_accounts.casa.loan", {
                  defaultValue: "Loan",
                })}
              {account.accountType === "WA" &&
                t("pages.Add_Bene.wallet", {
                  defaultValue: "Wallet",
                })}
            </>
          ),
        },
        {
          title: "Account Name",
          key: "acctShortName",
          width: 200,
          render: (account) => (
            <>
              <span className="d-flex justify-content-between">
                <span style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }} title={account.acctShortName}>{account.acctShortName || "-"}</span>
                <span>
                  <MdOutlineEdit
                    onClick={() => {
                      setVisible(true);
                      setSelectedDetails(account);
                    }}
                    className="mx-2"
                    style={{ marginTop: "-5px", fontSize: 15 }}
                  />
                </span>
              </span>
            </>
          ),
        },
        ...(dataSource.some((item) => item.branchName)
    ? [
        {
          title: "Branch Name",
          dataIndex: "branchName",
          key: "branchName",
          width: 130,
          ellipsis: true,
        },
      ]
    : []),
        {
          title: (
            <span>
              Available Balance{" "}
              <span
                onClick={toggleVisibility}
                className="mx-2"
                style={{ cursor: "pointer" }}
              >
                {isHidden ? (
                  <AiOutlineEyeInvisible
                    className="primary-color"
                    fontSize="17px"
                  />
                ) : (
                  <AiOutlineEye className="primary-color" fontSize="17px" />
                )}
              </span>
            </span>
          ),
          key: "avlBalance",
          width: 200,
          align: "right",

          render: (account) => (
            <>
              <span>
                {isHidden ? (
                  <span>
                    {`${account.accountCurrency} ********`}
                    {/* <span style={{ fontSize: "11px" }}>XX</span> */}
                  </span>
                ) : (
                  amountFormat(account.avlBalance, account.accountCurrency)
                )}
              </span>
            </>
          ),
        },
        {
          title: (
            <span>
              Current Balance{" "}
              <span
                onClick={toggleVisibility}
                className="mx-2"
                style={{ cursor: "pointer" }}
              >
                {isHidden ? (
                  <AiOutlineEyeInvisible
                    className="primary-color"
                    fontSize="17px"
                  />
                ) : (
                  <AiOutlineEye className="primary-color" fontSize="17px" />
                )}
              </span>
            </span>
          ),
          key: "currentBalance",
          width: 200,
          align: "right",
          render: (account) => (
            <>
              <span>
                {isHidden ? (
                  <span>
                    {`${account.accountCurrency} ********`}
                    {/* <span style={{ fontSize: "11px" }}>XX</span> */}
                  </span>
                ) : (
                  amountFormat(account.currentBalance, account.accountCurrency)
                )}
              </span>
            </>
          ),
        },
      ]}
    />
  );
}
